/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mark_ReadInputs */

const en_mark_read = /** @type {(inputs: Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Read`)
};

const id_mark_read = /** @type {(inputs: Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tandai Telah Dibaca`)
};

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const es_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const fr_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const de_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const ja_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const zh_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const ar_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const it_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const ru_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const pt_mark_read = en_mark_read;

/** @type {(inputs: Mark_ReadInputs) => LocalizedString} */
const ko_mark_read = en_mark_read;

/**
* | output |
* | --- |
* | "Mark Read" |
*
* @param {Mark_ReadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mark_read = /** @type {((inputs?: Mark_ReadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mark_ReadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mark_read(inputs)
	if (locale === "es") return es_mark_read(inputs)
	if (locale === "fr") return fr_mark_read(inputs)
	if (locale === "de") return de_mark_read(inputs)
	if (locale === "ja") return ja_mark_read(inputs)
	if (locale === "zh") return zh_mark_read(inputs)
	if (locale === "ar") return ar_mark_read(inputs)
	if (locale === "id") return id_mark_read(inputs)
	if (locale === "it") return it_mark_read(inputs)
	if (locale === "ru") return ru_mark_read(inputs)
	if (locale === "pt") return pt_mark_read(inputs)
	return ko_mark_read(inputs)
});